import { ExpandMore, PreviewOutlined } from "@mui/icons-material";
import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Grid,
  Stack,
  Typography,
} from "@mui/material";
import { deliveryNoteBusiness } from "api/bussiness/delivery-note/delivery-note-business";
import { DeliveryNotesPermission } from "commons/enum/permission";
import { dateTimeDisplay } from "commons/ultilities/date/dayjs";
import { observer } from "mobx-react-lite";
import { IDeliveryNoteItemProperties } from "mobx-stores/_models/delivery-note/delivery-note-item";
import { IProduct } from "mobx-stores/_models/products/product";
import { useStores } from "mobx-stores/_root-store";
import { CustomerDealingAndActiveInfo } from "pages/common/customer-dealing-and-active-info";
import { ProductNameAndActiveInfo } from "pages/common/product-name-and-active-info";
import { useCallback, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { NumberText } from "share-components/atomics/number-text";
import { PropertyInfo } from "share-components/atomics/property-info";
import {
  EditButton,
  GoBackIconButton,
  RemoveButton,
} from "share-components/mui-wrap/button/action-button";
import { HoverMenuButton } from "share-components/mui-wrap/button/hover-menu-button";
import { PageContentScrollableContainer } from "share-components/templates/page/page-content-container";
import { PageDetailContainer } from "share-components/templates/page/page-detail-container";
import { PageHeaderContainer } from "share-components/templates/page/page-header-container";
import { EditDeliveryNote } from "../edit-delivery-note/edit-delivery-note";
import { DeliveryNotePrintPreview } from "./delivery-note-print-preview";
import { DeliveryNotePrint2Preview } from "./delivery-note-print2-preview";
export const DeliveryNoteDetail = observer(() => {
  const { deliveryNoteId } = useParams();
  const {
    deliveryNoteManagement: { getDeliveryNoteDetail, openEdit },
  } = useStores();
  useEffect(() => {
    if (deliveryNoteId) {
      getDeliveryNoteDetail(deliveryNoteId);
    }
  }, [getDeliveryNoteDetail, deliveryNoteId]);
  return (
    <PageDetailContainer>
      <PageHeaderContainer direction={"row"} justifyContent={"space-between"}>
        <Header></Header>
      </PageHeaderContainer>
      <PageContentScrollableContainer>
        <Content></Content>
      </PageContentScrollableContainer>

      <>{openEdit && <EditDeliveryNote></EditDeliveryNote>}</>
    </PageDetailContainer>
  );
});
type HeaderProps = {};
const Header = observer((props: HeaderProps) => {
  const {
    deliveryNoteManagement: {
      deliveryNoteDetail,
      setProp: setDeliveryNoteManagementProp,
      openPrintPreview,
      openPrint2Preview,
    },
    deleteConfirmationStore: { setProp, setDeletionCallback },
  } = useStores();
  const navigate = useNavigate();
  const goBack = useCallback(() => {
    navigate(-1);
  }, [navigate]);
  const onDelete = useCallback(
    async (id: string) => {
      if (id) {
        await deliveryNoteBusiness.delete(id);
        goBack();
      }
    },
    [goBack],
  );
  const removeHandler = useCallback(() => {
    setProp("open", true);
    setDeletionCallback(() => {
      if (!deliveryNoteDetail?.id) return;
      onDelete(deliveryNoteDetail?.id);
    });
  }, [deliveryNoteDetail, onDelete, setDeletionCallback, setProp]);

  const editHandler = useCallback(() => {
    setDeliveryNoteManagementProp("openEdit", true);
  }, [setDeliveryNoteManagementProp]);

  const openPrintPreviewHandler = useCallback(() => {
    setDeliveryNoteManagementProp("openPrintPreview", true);
  }, [setDeliveryNoteManagementProp]);

  const openPrint2PreviewHandler = useCallback(() => {
    setDeliveryNoteManagementProp("openPrint2Preview", true);
  }, [setDeliveryNoteManagementProp]);

  return (
    <>
      <Stack
        direction={"row"}
        justifyItems={"center"}
        spacing={1}
        alignItems={"center"}
      >
        <GoBackIconButton onClick={goBack}></GoBackIconButton>
        <Typography variant="subtitle2">{`Thông tin chi tiết `}</Typography>
      </Stack>
      <Stack direction={"row"} justifyItems={"center"} spacing={1}>
        {/* <PrintPreviewButton
          accessPermission={[DeliveryNotesPermission.PrintDeliveryNote]}
          onClick={openPrintPreviewHandler}
        >
          In phiếu giao hàng
        </PrintPreviewButton> */}

        <HoverMenuButton
          label="In phiếu giao hàng"
          buttonProps={{
            variant: "outlined",
            startIcon: <PreviewOutlined />,
          }}
          options={[
            {
              id: "T1",
              label: "Mẫu 1: In kim",
              onClick: openPrintPreviewHandler,
            },
            {
              id: "T2",
              label: "Mẫu 2: In A5",
              onClick: openPrint2PreviewHandler,
            },
          ]}
        ></HoverMenuButton>

        <RemoveButton
          accessPermission={[DeliveryNotesPermission.Delete]}
          onClick={removeHandler}
        ></RemoveButton>
        <EditButton
          accessPermission={[DeliveryNotesPermission.Update]}
          onClick={editHandler}
        ></EditButton>
      </Stack>

      <>{openPrintPreview && <DeliveryNotePrintPreview />}</>
      <>{openPrint2Preview && <DeliveryNotePrint2Preview />}</>
    </>
  );
});

const Content = observer(() => {
  const {
    deliveryNoteManagement: { deliveryNoteDetail },
  } = useStores();
  return (
    <Stack>
      <Grid container spacing={2}>
        <Grid item xs={6}>
          <PropertyInfo
            title="Ngày:"
            value={dateTimeDisplay(deliveryNoteDetail?.date || "")}
          ></PropertyInfo>
        </Grid>

        <Grid item xs={6}>
          <PropertyInfo
            title="Số phiếu:"
            value={deliveryNoteDetail?.number || ""}
          ></PropertyInfo>
        </Grid>
        <Grid item xs={6}>
          <PropertyInfo
            title="Đơn đặt hàng:"
            value={deliveryNoteDetail?.purchaseOrder?.poNumber || ""}
          ></PropertyInfo>
        </Grid>
        <Grid item xs={6}>
          <PropertyInfo
            title="Tên giao dịch:"
            value={
              deliveryNoteDetail?.customer ? (
                <CustomerDealingAndActiveInfo
                  customer={deliveryNoteDetail?.customer}
                ></CustomerDealingAndActiveInfo>
              ) : (
                ""
              )
            }
          ></PropertyInfo>
        </Grid>
        <Grid item xs={6}>
          <PropertyInfo
            title="Người giao:"
            value={deliveryNoteDetail?.man || ""}
          ></PropertyInfo>
        </Grid>

        <Grid item xs={6}>
          <PropertyInfo
            title="Biển số xe:"
            value={deliveryNoteDetail?.licensePalate || ""}
          ></PropertyInfo>
        </Grid>

        <Grid item xs={12}>
          <PropertyInfo
            title="Địa chỉ giao:"
            value={deliveryNoteDetail?.deliveryAddress?.address || ""}
          ></PropertyInfo>
        </Grid>

        <Grid item xs={12}>
          <PropertyInfo
            title="Ghi chú:"
            value={deliveryNoteDetail?.note || ""}
          ></PropertyInfo>
        </Grid>
      </Grid>
      <ListDeliveryNoteItem></ListDeliveryNoteItem>
    </Stack>
  );
});

const ListDeliveryNoteItem = observer(() => {
  const {
    deliveryNoteManagement: { deliveryNoteDetail },
  } = useStores();
  return (
    <Box
      flex={1}
      sx={{
        borderRadius: (theme) => theme.shape.borderRadius,
        padding: "10px",
        backgroundColor: (theme) => theme.palette.background.default,
        marginTop: "20px",
      }}
    >
      {deliveryNoteDetail?.items.map((x) => (
        <DeliveryNoteItem key={x.id} deliveryNoteItem={x}></DeliveryNoteItem>
      ))}
    </Box>
  );
});
type DeliveryNoteItemProps = {
  deliveryNoteItem: IDeliveryNoteItemProperties;
};
const DeliveryNoteItem = observer(
  ({ deliveryNoteItem }: DeliveryNoteItemProps) => {
    return (
      <Accordion>
        <AccordionSummary expandIcon={<ExpandMore />}>
          <Grid container>
            <Grid item xs={3}>
              <PropertyInfo
                title="Mã hàng:"
                value={deliveryNoteItem?.product?.code || ""}
              ></PropertyInfo>
            </Grid>
            <Grid item xs={3}>
              <PropertyInfo
                title="Tên hàng:"
                value={
                  deliveryNoteItem?.product ? (
                    <ProductNameAndActiveInfo
                      product={deliveryNoteItem?.product as IProduct}
                    ></ProductNameAndActiveInfo>
                  ) : (
                    ""
                  )
                }
              ></PropertyInfo>
            </Grid>
            <Grid item xs={3}>
              <PropertyInfo
                title="Mã vạch:"
                value={deliveryNoteItem?.product?.barcode || ""}
              ></PropertyInfo>
            </Grid>
          </Grid>
        </AccordionSummary>
        <AccordionDetails>
          <Grid container spacing={2}>
            <Grid item xs={3}>
              <PropertyInfo
                title="ĐVT:"
                value={deliveryNoteItem?.product?.unitOfCalculation || ""}
              ></PropertyInfo>
            </Grid>
            <Grid item xs={3}>
              <PropertyInfo
                title="Số lượng (pcs):"
                value={
                  <NumberText value={deliveryNoteItem?.amount}></NumberText>
                }
              ></PropertyInfo>
            </Grid>

            <Grid item xs={3}>
              <PropertyInfo
                title="Trọng lượng (kg):"
                value={
                  <NumberText value={deliveryNoteItem?.weight}></NumberText>
                }
              ></PropertyInfo>
            </Grid>

            <Grid item xs={3}>
              <PropertyInfo
                title="M/H:"
                value={<NumberText value={deliveryNoteItem?.mh}></NumberText>}
              ></PropertyInfo>
            </Grid>

            <Grid item xs={3}>
              <PropertyInfo
                title="Kiện:"
                value={
                  <NumberText value={deliveryNoteItem?.package}></NumberText>
                }
              ></PropertyInfo>
            </Grid>
            <Grid item xs={12}>
              <PropertyInfo
                title="Ghi chú:"
                value={deliveryNoteItem.note || ""}
              ></PropertyInfo>
            </Grid>
          </Grid>
        </AccordionDetails>
      </Accordion>
    );
  },
);
